/**
 * @generated SignedSource<<4d26e101963f275ca68c298e0ccbc73d>>
 * @relayHash de15b354a95e769123fe60dd15a7f8cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1

import type { ConcreteRequest } from 'relay-runtime';
export type globalThemeManagementGetPreferenceQuery$variables = {
  accountId: string;
};
export type globalThemeManagementGetPreferenceQuery$data = {
  readonly settings_userPreferencesGlobal: {
    readonly theme: string | null | undefined;
  } | null | undefined;
};
export type globalThemeManagementGetPreferenceQuery = {
  response: globalThemeManagementGetPreferenceQuery$data;
  variables: globalThemeManagementGetPreferenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_userPreferencesGlobal",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "globalThemeManagementGetPreferenceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "globalThemeManagementGetPreferenceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "c25b80273fbbe1163657875e0d88e9dc3cbe805468bd71ed9c234670648be2d1",
    "metadata": {},
    "name": "globalThemeManagementGetPreferenceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "82db627aaf32cacee0220d3e6d6a9c59";

export default node;
